var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReloadInBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7226 8.75698C10.0936 9.72002 9.15412 10.439 8.06018 10.7946C6.96624 11.1502 5.78359 11.121 4.70852 10.7119C3.63345 10.3028 2.7306 9.53834 2.14981 8.54545C1.56902 7.55257 1.34522 6.39092 1.51555 5.25332C1.68587 4.11572 2.24009 3.07057 3.08621 2.29132C3.93233 1.51208 5.01948 1.0456 6.16723 0.969299C7.31497 0.893001 8.4543 1.21148 9.39613 1.87187C10.3379 2.53226 11.0256 3.49486 11.345 4.5999",
    stroke: "#797B80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5425 0.957977V4.62464L7.9043 4.17273",
    stroke: "#797B80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadInBudget);
export default __webpack_public_path__ + "static/media/reloadInBudget.5f567a469d6d88794813914c29703b1f.svg";
export { ForwardRef as ReactComponent };